var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#008DE4",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.045 6.5H9.238L8.84 8.786l4.337.005c2.136 0 2.768.796 2.75 2.118-.01.677-.295 1.822-.419 2.193-.329.989-1.005 2.118-3.54 2.113l-4.216-.002-.4 2.287h4.796c1.692 0 2.412-.202 3.173-.564 1.689-.8 2.694-2.511 3.096-4.745.6-3.325-.147-5.691-4.372-5.691Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.164 10.851c-1.259 0-1.44.843-1.558 1.352-.156.666-.208.936-.208.936h4.922c1.259 0 1.439-.842 1.558-1.351.156-.667.207-.937.207-.937h-4.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.36d50a4d47f0bb7fa78a1c5bf4803382.svg";
export { ForwardRef as ReactComponent };